<template>
  <div class="known-business-entity-contact-list">
    <ul class="space-y-2">
      <li v-for="(kbec, i) in modelValue" :key="kbec.id">
        <KnownBusinessEntityContactComponent
          v-model="modelValue[i]"
          @kbec-changed="$emit('kbecChanged', $event)"
          ref="knownBusinessEntityContactComponents"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, type Ref } from "vue"
import type { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import KnownBusinessEntityContactComponent from "@/components/known_business_entity_contact/KnownBusinessEntityContactComponent.vue"
defineEmits(["update:modelValue", "kbecChanged"])

const modelValue = defineModel<KnownBusinessEntityContact[]>({ required: true })

const knownBusinessEntityContactComponents: Ref<(typeof KnownBusinessEntityContactComponent)[]> =
  ref([])
function focusRoleButton(kbec: KnownBusinessEntityContact) {
  const index = modelValue.value.findIndex((kbecItem) => kbecItem.id === kbec.id)
  if (index !== -1) {
    knownBusinessEntityContactComponents.value[index].focusRoleButton()
  }
}

function focusEmailInput(kbec: KnownBusinessEntityContact) {
  const index = modelValue.value.findIndex((kbecItem) => kbecItem.id === kbec.id)
  if (index !== -1) {
    knownBusinessEntityContactComponents.value[index].focusEmailInput()
  }
}

defineExpose({ focusRoleButton, focusEmailInput })
</script>

<style scoped></style>
